import { formatPrice, mapProductTypeToProductCategory } from "@grandvisionhq/svc-tealium/utils";
const mapProductToTealiumProperties = (product) => {
  const productTypeName = product.productType;
  let originalPrice = "";
  let discountedPrice = "";
  const price = product.masterVariant.pricing?.price;
  if (price) {
    originalPrice = formatPrice(price.originalPrice, price?.isCentAmount);
    discountedPrice = formatPrice(price.discount?.price ?? price?.originalPrice, true);
  }
  const isLenses = productTypeName === "Contact-lenses";
  const isProductWithAFrame = productTypeName === "Frames" || productTypeName === "Sunglasses" || productTypeName === "Ready-readers";
  const productProperties = {
    Category: mapProductTypeToProductCategory(productTypeName),
    Price: discountedPrice,
    PriceFull: originalPrice,
    ModelName: isLenses ? product.name.en : product.masterVariant.name
  };
  if (isProductWithAFrame || isLenses) {
    productProperties.LensType = "PLANO";
  }
  return productProperties;
};
export {
  mapProductToTealiumProperties
};
//# sourceMappingURL=map-product-to-tealium-properties.js.map
